import { RootState } from "@/store/store";
import { getInfrastructureArchitectureRecommendationEndpointSelector } from "@/store/infrastructure-architecture/selectors/getInfrastructureArchitectureRecommendationEndpointSelector";
import { selectInfrastructureArchitectureStateInLocalStorage } from "@/store/infrastructure-architecture/utils/helpers/selectInfrastructureArchitectureStateInLocalStorage";

export const infrastructureArchitectureRecommendationDataSelector = (
  state: RootState,
) => {
  const response =
    getInfrastructureArchitectureRecommendationEndpointSelector(state);
  const { recommendationData } =
    selectInfrastructureArchitectureStateInLocalStorage();

  return !response?.isUninitialized ? response.data : recommendationData;
};
